<template>
  <div>
    <div class="breadcrumb-area">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2">
            <div class="breadcrumb-wrapper">
              <ul class="breadcrumb-list">
                <li>
                  <router-link :to="{ name: 'HomePage' }">
                    <i class="fa fa-home"></i>
                    Home
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'ProductList' }">
                    <i class="fa fa-stars"></i>
                    Star Collection
                  </router-link>
                </li>
                <li class="active">
                  <i class="fa fa-images"></i>
                  Saved Collections
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-content-wrapper">
      <div class="shopping-cart-area">
        <div class="container">
          <div class="text-center" v-if="loading">
            <loading />
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="cart-table-container">
                <div
                  v-if="collections && collections.length"
                  class="d-lg-none d-md-block text-end"
                >
                  <a
                    href="javascript:"
                    class="btn btn-sm btn-danger mb-2"
                    title="Remove all"
                    @click="removeAllCollections"
                  >
                    <i class="fa fa-trash"></i>
                  </a>
                </div>
                <table class="cart-table">
                  <thead>
                    <tr class="text-center">
                      <th class="product-name">
                        Collection Name
                      </th>
                      <th class="product-quantity">
                        Items
                      </th>
                      <th class="product-quantity">Status</th>
                      <th class="product-remove">
                        <a
                          v-if="collections && collections.length"
                          href="javascript:"
                          class="text-danger"
                          title="Remove all"
                          @click="removeAllCollections"
                        >
                          <i class="fa fa-trash"></i>
                        </a>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="collection in collections"
                      :key="`collection-${collection.Id}`"
                    >
                      <td class="p-3" style="max-width:300px;">
                        <router-link
                          :to="{
                            name: 'MyCollection',
                            params: { cartId: collection.Id },
                          }"
                          class="text-primary fw-bold"
                        >
                          <i class="fa fa-couch"></i>
                          {{ collection.Name }}
                        </router-link>
                      </td>
                      <td class="text-center p-3">
                        {{
                          collection.CartItems ? collection.CartItems.length : 0
                        }}
                      </td>
                      <td class="text-center p-3">
                        <a
                          href="javascript:"
                          :class="
                            collection.Status == $const.CART_STATUS.Unsaved
                              ? 'text-warning'
                              : 'text-success'
                          "
                          :title="
                            `Tap to change to ${
                              collection.Status == $const.CART_STATUS.Unsaved
                                ? 'Saved'
                                : 'Unsaved'
                            }`
                          "
                          @click="changeStatus(collection)"
                        >
                          <i
                            v-if="
                              collection.Status == $const.CART_STATUS.Unsaved
                            "
                            class="fa fa-unlock-alt"
                          ></i>
                          <i v-else class="fa fa-lock-alt"></i>
                          {{ $const.CART_STATUS_TEXT[collection.Status] }}
                        </a>
                      </td>
                      <td class="product-remove text-center p-3">
                        <loading v-if="deletings.includes(collection.Id)" />
                        <a
                          v-else
                          href="javascript:"
                          class="d-inline-block"
                          title="Remove this item"
                          @click="removeCollection(collection)"
                        >
                          <i class="fa fa-times"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loading from "@/components/Loading.vue";
export default {
  components: {
    loading,
  },
  data() {
    return {
      loading: false,
      collections: [],
      deletings: [],
    };
  },
  mounted() {
    this.loadCollections();
  },
  methods: {
    async loadCollections() {
      this.loading = true;
      try {
        let resp = await this.$http.get(`odata/Cart`, {
          params: {
            $select: `Id,Name,Status`,
            $top: 1000,
            $expand: `CartItems`,
          },
        });
        if (resp && resp.status == 200) {
          this.collections = resp.data.value;
        }
      } catch (error) {
        this.$swal({ text: error.message });
      }
      this.loading = false;
    },

    async deleteCollection(collection) {
      let cartId = collection.Id;
      this.deletings.push(cartId);

      let cartItems = collection.CartItems;
      if (cartItems && cartItems.length) {
        await this.$func.asyncForEach(cartItems, async (cartItem) => {
          await this.$http.delete(`odata/CartItem/${cartItem.Id}`);
        });
      }
      await this.$http.delete(`odata/Cart/${cartId}`);

      this.deletings = this.deletings.filter((_) => _ != cartId);
      this.collections = this.collections.filter((_) => _.Id != cartId);

      if (collection.Status == this.$const.CART_STATUS.Unsaved) {
        this.$collection.dispatch("getUserCollection");
      }
    },

    async removeCollection(collection) {
      let result = await this.$swal({
        text: "Do you really want to remove this collection?",
        icon: "question",
        showCancelButton: true,
      });
      if (result && result.isConfirmed) {
        await this.deleteCollection(collection);
      }
    },

    async removeAllCollections() {
      let result = await this.$swal({
        text: "Do you really want to remove all collections?",
        icon: "question",
        showCancelButton: true,
      });
      if (result && result.isConfirmed) {
        let collections = this.collections;
        await this.$func.asyncForEach(collections, async (collection) => {
          await this.deleteCollection(collection);
        });
      }
    },

    async changeStatus(collection) {
      let newStatus =
        collection.Status == this.$const.CART_STATUS.Unsaved
          ? this.$const.CART_STATUS.Saved
          : this.$const.CART_STATUS.Unsaved;
      let resp = await this.$http.patch(`odata/Cart/${collection.Id}`, {
        Status: newStatus,
      });
      if (resp && resp.status == 204) {
        if (newStatus == this.$const.CART_STATUS.Unsaved) {
          let others = this.collections.filter((_) => _.Id != collection.Id);
          await this.$func.asyncForEach(others, async (other) => {
            await this.$http.patch(`odata/Cart/${other.Id}`, {
              Status: this.$const.CART_STATUS.Saved,
            });
          });
        }
        this.loadCollections();
        this.$collection.dispatch("getUserCollection");
      }
    },
  },
};
</script>
